import { Link } from '../lib/router';
import { Empty } from '../components/ui';

export function NotFound() {
  return (
    <Empty icon="lock" title="Nothing here, or no clearance">
      This page does not exist or your roles do not unlock it. <Link to="/">Back to home</Link>
    </Empty>
  );
}
